import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { TranslationsService } from '../../services/translations/translations.service';

@Directive({
  selector: '[appTranslate]',
})
export class TranslateDirective implements OnInit {
  @Input()
  public appTranslate = '';
  public parser;
  constructor(
    private readonly elementRef: ElementRef,
    private readonly translationsService: TranslationsService
  ) {
    this.parser = new DOMParser();
  }

  ngOnInit(): void {
    this.translationsService.ready.subscribe(() => this.update());
    this.update();
  }

  private update(): void {
    const translation =
      this.translationsService.getValue(this.appTranslate) || this.appTranslate;

    this.elementRef.nativeElement.innerHTML = this.stringToHTML(translation);
  }

  private stringToHTML(str: string): string {
    var doc = this.parser.parseFromString(str, 'text/html');
    return doc.body.innerHTML;
  }
}
